import {
  getSharedAudioContext,
  resumeSharedAudioContext,
} from './getSharedAudioContext'

/** Флаг: разблокировка аудио уже выполнена */
let audioUnlocked = false

/**
 * Тихое воспроизведение для снятия autoplay-ограничения браузера.
 */
const unlockAudioPlayback = (): void => {
  if (audioUnlocked) {
    return
  }

  audioUnlocked = true

  // Разблокируем общий Web Audio context по жесту пользователя
  void resumeSharedAudioContext()

  try {
    const audio = new Audio('/sounds/new-order.mp3')
    audio.volume = 0.001
    void audio
      .play()
      .then(() => {
        audio.pause()
        audio.currentTime = 0
      })
      .catch(() => {
        // mp3 может отсутствовать — тихий буфер через общий AudioContext
        try {
          const context = getSharedAudioContext()

          if (!context) {
            return
          }

          const buffer = context.createBuffer(1, 1, 22050)
          const source = context.createBufferSource()
          source.buffer = buffer
          source.connect(context.destination)
          source.start(0)
        } catch {
          // разблокировка не критична
        }
      })
  } catch {
    // разблокировка не критична
  }
}

/**
 * Однократно разблокирует автовоспроизведение аудио после первого жеста пользователя.
 * @returns функция отписки от pointerdown/keydown
 */
export const bindAudioUnlockOnFirstGesture = (): (() => void) => {
  const handleGesture = (): void => {
    unlockAudioPlayback()
    cleanup()
  }

  const cleanup = (): void => {
    document.removeEventListener('pointerdown', handleGesture)
    document.removeEventListener('keydown', handleGesture)
  }

  document.addEventListener('pointerdown', handleGesture)
  document.addEventListener('keydown', handleGesture)

  return cleanup
}
